import { Box, Divider, Typography } from '@mui/material'
import PlanItem from './PlanItem'
import DiscountPrice from '../PlanRecommendation/DiscountPrice'
import { useMemo } from 'react'

export default function PlanProductItem({
	group = {},
	selectedProducts = [],
	discountConfiguration = [],
	onChange
}: any) {
	const dailyPrice = Math.round(group.price / 7)
	const dailyPriceInDollars = dailyPrice / 100

	const discount = useMemo(() => {
		return discountConfiguration?.find((d: any) => d.applyTo === 'subtotal')
	}, [discountConfiguration])

	const priceStyles = discount ? styles.discounted : {}

	return (
		<Box key={`price-${group.price}`} sx={styles.root}>
			<Typography variant="h6" textAlign={'center'}>
				Starting at{' '}
				<Box component="span" sx={priceStyles}>
					${dailyPriceInDollars}/day{' '}
				</Box>
				{discount && (
					<DiscountPrice
						price={dailyPriceInDollars}
						discount={discount?.percent}
						context={'percent'}
					/>
				)}
			</Typography>
			<Divider sx={{ mt: 2, mb: 2 }} />
			<Box sx={styles.content}>
				{group.products.map((product: any) => (
					<PlanItem
						key={product.id}
						id={product.id}
						selected={selectedProducts.includes(product.id)}
						title={product.name}
						description={product.description}
						image={product.image}
						onChange={(selected: boolean) => onChange(selected, product)}
					/>
				))}
			</Box>
		</Box>
	)
}

const styles = {
	root: {
		display: 'flex',
		flex: 1,
		flexDirection: 'column'
	},
	content: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'center',
		flex: 1,
		// justifyContent: 'space-between',
		pl: 3,
		pr: 3,
		gap: 3
	},
	discounted: {
		textDecoration: 'line-through'
	}
}
